// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductReport":"eo_a bhv_a bhv_x bhv_j bhv_u bhv_bc bhv_pp bhv_up"};